import { ContractVersion } from '~/typings/context';
import { ContractTag } from '~/typings/graphql';

export const TEST_TERMS = {
  general: [
    {
      id: 612,
      contractId: 31,
      contractType: 'privacy',
      displayName: 'Privacy Policy',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 820,
      contractId: 43,
      contractType: 'terms',
      displayName: 'General Terms of Service',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  waitlist: [
    {
      id: 612,
      contractId: 31,
      contractType: 'privacy',
      displayName: 'Privacy Policy',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 820,
      contractId: 43,
      contractType: 'terms',
      displayName: 'General Terms of Service',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 77181,
      contractId: 1,
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  illinoisABP: [
    {
      id: 77507,
      contractId: 38,
      contractType: 'disclosure',
      displayName: 'Illinois Shines Community Disclosure Form',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  standardSolar: [
    {
      id: 77181,
      contractId: 1,
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 77177,
      contractId: 2,
      contractType: 'disclosure',
      displayName: 'Community Distributed Generation Disclosure Form',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 77214,
      contractId: 3,
      contractType: 'direct',
      displayName: 'Community Distributed Generation Credit Sale and Purchase Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  nysegSolar: [
    {
      id: 77181,
      contractId: 4,
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 51029,
      displayName: 'E-billing Consent',
      contractId: 5,
      contractType: 'data-consent',
      fileUrl: '',
      scrollRequired: false,
      tag: ContractTag.Nyseg,
    },
  ],
  scrollableSolar: [
    {
      id: 77181,
      contractId: 6,
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 679,
      contractId: 16,
      contractType: 'disclosure',
      displayName: 'SMART Participant Customer Disclosure Form',
      scrollRequired: true,
      fileUrl: '/scrollable-contract-679.pdf',
    },
  ],
  lmi: [
    {
      contractType: 'lmi',
      displayName: 'Subscriber Verification of Low to Moderate Income Status',
      fileUrl: '',
      id: 76900,
      contractId: 8,
      scrollRequired: false,
    },
  ],
  taggedLmi: [
    {
      contractType: 'lmi',
      displayName: 'Subscriber Verification of Low to Moderate Income Status',
      fileUrl: '',
      id: 76900,
      contractId: 8,
      scrollRequired: false,
      tag: ContractTag.Energywell,
    },
  ],
} satisfies Record<string, Partial<ContractVersion>[]>;
